import React from "react";
import { FileText, FileWarning, X } from "lucide-react";
import { MB_FILE_SIZE } from "./hooks/useFileValidation";
import { cn } from "utils";

export const FilePreview = ({
  selectedFile,
  isFileInvalid,
  isFileTooLarge,
  onRemoveFile,
}) => {
  if (!selectedFile) {
    return null;
  }

  const hasError = isFileInvalid || isFileTooLarge;

  return (
    <div className="w-full max-w-[446px] text-center flex flex-col gap-2">
      <div className="flex items-center justify-center">
        {hasError ? (
          <FileWarning size={30} />
        ) : (
          <FileText size={32} color="white" className="fill-[#5A5E6E]" />
        )}
      </div>
      <div className="mb-2 flex items-center justify-center gap-2">
        {!hasError ? (
          <>
            <div className="max-w-[300px] truncate font-['Inter'] font-normal text-base leading-[180%] tracking-[0%] text-[#222222]">
              {selectedFile.name}
            </div>
            <div className="font-['Inter'] font-normal text-sm leading-[180%] tracking-[0%] text-center align-middle text-[#5A5E6E]">
              {(selectedFile.size / 1024 / 1024).toFixed(2)}MB
            </div>
            <button
              type="button"
              onClick={onRemoveFile}
              className="flex items-center justify-center rounded-full p-1 transition-colors duration-200 hover:bg-gray-100"
              aria-label="Remove selected resume"
            >
              <X size={18} className="text-[#5A5E6E]" />
            </button>
          </>
        ) : (
          <div className="mb-11 flex flex-col gap-2 text-[#334155]">
            <div
              className={cn(
                "font-['Inter'] font-normal text-base leading-[180%] tracking-[0%]",
                {
                  "text-red-400": !isFileInvalid,
                }
              )}
            >
              File "{selectedFile.name}"{" "}
              {isFileInvalid ? "is not supported" : "is too large"}
            </div>
            <div className="font-['Inter'] font-normal text-sm leading-[180%] tracking-[0%] text-center align-middle text-[#5A5E6E]">
              {(selectedFile.size / 1024 / 1024).toFixed(2)}MB
            </div>
            <div className="font-['Inter'] font-normal text-sm leading-[180%] tracking-[0%] text-center align-middle text-[#5A5E6E]">
              {isFileInvalid
                ? "Please upload a valid file"
                : `Please upload a file smaller than ${MB_FILE_SIZE}mb`}
            </div>
            <div className="font-['Inter'] font-normal text-xs leading-[180%] tracking-[0%] text-[#5A5E6E]">
              Supports PDF, DOC, DOCS (max {MB_FILE_SIZE}mb)
            </div>
          </div>
        )}
      </div>
    </div>
  );
};
